export const CompPlexResidentialLeaseEvents = {
  EDIT_COMP_UPDATED: 'compplex-rrc-edit-comp-updated',
  EDIT_COMP_CLOSED: 'compplex-rrc-edit-comp-closed',
  FOUND_COMP_ADDED: 'compplex-rrc-found-comp-added',
  MAP_COMP_ADDED: 'compplex-rrc-map-comp-added',
  MAP_COMP_REMOVED: 'compplex-rrc-map-comp-removed',
  MAP_EDIT_MODAL_OPENED: 'compplex-rrc-map-edit-modal-opened',
  MAP_EDIT_MODAL_CLOSED: 'compplex-rrc-map-edit-modal-closed',
  ERROR: 'compplex-error',
};
